import React from 'react';
import Table from '../../components/Table';
import 'dayjs/locale/pt';
import { useBiomeasures } from 'hooks/useBiomeasures';

function Biomeasures() {
  const {
    biomeasures,
    columns,
    columnsForExport,
    errors,
    errorsWhenPosting,
    exportData,
    openProgress,
    handleImportDataPost,
    handleCloseSnackbar,
  } = useBiomeasures();

  return (
    <Table
      title="Biometrias"
      titleForImportExport="Biometrias"
      route="/biomeasures/"
      routeAdd="/biomeasure/"
      columns={columns}
      columnsForExport={columnsForExport}
      data={biomeasures}
      dataLoaded={openProgress}
      exportData={exportData}
      hasError={errors.length > 0}
      errorsPost={errorsWhenPosting}
      onPost={handleImportDataPost}
      importButtonVisible
      onCloseSnackbar={handleCloseSnackbar}
    />
  );
}

export default Biomeasures;
